import React, { useState, useEffect } from "react";  // <-- Add useEffect
import "./FloatingEnquiryForm.scss";
import emailjs from "@emailjs/browser";

const FloatingEnquiryForm = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [closing, setClosing] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);   // <-- NEW

  const openForm = () => {
    setIsFormOpen(true);
    setIsSent(false);
  };

  const closeForm = () => {
    setClosing(true);
    setAnimateIn(false); // Reset animation
    setTimeout(() => {
      setIsFormOpen(false);
      setClosing(false);
      setIsSending(false);
      setIsSent(false);
    }, 400);
  };

  useEffect(() => {
    if (isFormOpen) {
      setTimeout(() => {
        setAnimateIn(true);
      }, 10); // wait 10ms to allow mounting, THEN animate
    }
  }, [isFormOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);

    emailjs.sendForm(
      'service_xmnizsk',  
      'template_kzp7yhu', 
      e.target,
      'xex6r3rQOCdCKvvFA'
    )
    .then((result) => {
      console.log(result.text);
      setIsSending(false);
      setIsSent(true);
      e.target.reset();
    }, (error) => {
      console.log(error.text);
      setIsSending(false);
      alert('An error occurred, please try again.');
    });
  };

  return (
    <>
      <button className="floating-enquiry-button" onClick={openForm}>
        Enquire here today
      </button>

      {(isFormOpen || closing) && (
        <>
          <div 
            className={`form-overlay ${closing ? 'closing' : (animateIn ? 'opening' : '')}`} 
            onClick={closeForm}
          ></div>

          <div className={`floating-enquiry-form ${closing ? 'closing' : animateIn ? 'opening' : 'hidden'}`}>

            <button className="close-button" onClick={closeForm}>
              &times;
            </button>

            <h3>Contact Me</h3>

            {isSent ? (
              <div className="thank-you-message">
                <p>✅ Thank you for reaching out! I'll be in touch soon.</p>
              </div>
            ) : (
                <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Your Name</label><br/>
                  <input type="text" name="name" required />
                </div>
                <div className="form-group">
                  <label>Your Email</label><br/>
                  <input type="email" name="email" required />
                </div>
                <div className="form-group">
                  <label>Your Phone Number</label><br/>
                  <input type="tel" name="phone" />
                </div>
                <div className="form-group">
                  <label>Enquiry Type</label><br/>
                  <select name="enquiry" required>
                    <option value="">Select...</option>
                    <option value="project">I have a project</option>
                    <option value="question">I have a question</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Town/City and Country</label><br/>
                  <input type="text" name="location" required />
                </div>
                <div className="form-group">
                  <label>I found you on...</label><br/>
                  <select name="source" required>
                    <option value="">Select...</option>
                    <option value="LinkedIn">LinkedIn</option>
                    <option value="Google">Google</option>
                    <option value="Referral">Referral</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>How can I help?</label><br/>
                  <textarea name="message" rows="4" required />
                </div>
  
                <button type="submit" className="submit-button" disabled={isSending}>
                  {isSending ? "Sending..." : "Send Message"}
                </button>
              </form>
  
            )}
          </div>
        </>
      )}
    </>
  );
};

export default FloatingEnquiryForm;
